import React from 'react';
import { MapPin } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Location = () => {
  const { t } = useTranslation();
  
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="text-cmv-green font-semibold text-sm uppercase tracking-wider">
            {t('location.label')}
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mt-4 mb-6">
            {t('location.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('location.subtitle')}
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            {/* Map */}
            <div className="rounded-2xl overflow-hidden shadow-xl h-[400px]">
              <iframe
                src="https://www.google.com/maps?q=42.33460872279079,-1.9182239318728704&hl=es&z=17&output=embed"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Ubicación CMV - NA-134, Km 49, San Adrián, Navarra"
              ></iframe>
            </div>

            {/* Info */}
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-cmv-green/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <MapPin className="text-cmv-green" size={24} />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">
                    {t('location.facilities')}
                  </h3>
                  <p className="text-gray-600 leading-relaxed mb-3">
                    NA-134, Km 49, 31570 San Adrián, Navarra
                  </p>
                  <a 
                    href="https://www.google.com/maps/dir/?api=1&destination=42.33460872279079,-1.9182239318728704"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center text-cmv-green hover:text-cmv-green-dark font-semibold text-sm transition-colors"
                  >
                    {t('location.directionsGoogle')}
                  </a>
                </div>
              </div>

              <div className="bg-gray-50 rounded-xl p-6">
                <h4 className="font-semibold text-gray-900 mb-4">{t('location.howToGet')}</h4>
                <ul className="space-y-3 text-gray-600">
                  <li className="flex items-start">
                    <span className="w-1.5 h-1.5 bg-cmv-green rounded-full mr-3 mt-2 flex-shrink-0"></span>
                    <span>{t('location.fromPamplona')}</span>
                  </li>
                  <li className="flex items-start">
                    <span className="w-1.5 h-1.5 bg-cmv-green rounded-full mr-3 mt-2 flex-shrink-0"></span>
                    <span>{t('location.fromLogrono')}</span>
                  </li>
                  <li className="flex items-start">
                    <span className="w-1.5 h-1.5 bg-cmv-green rounded-full mr-3 mt-2 flex-shrink-0"></span>
                    <span>{t('location.parking')}</span>
                  </li>
                </ul>
              </div>

              <div className="bg-cmv-green/10 rounded-xl p-6 border border-cmv-green/20">
                <p className="text-gray-700">
                  <strong className="text-cmv-green">{t('location.important')}</strong> {t('location.importantText')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Location;
